<template>

<core-modal v-on:close="onClose" :nopadding="true" icon="caret-left">

	<template v-slot:head>

		Set Default

	</template>

	<template v-slot:default>

        <p class="text">Choose the default view for your {{ context }}. It will also be the default view for other people viewing your {{ context }} if it's a public view.</p>

		<com-view v-model="model.default" />

	</template>

	<template v-slot:foot>

		<core-button theme="blue" :loading="is.loading" :disabled="!hasChanged" v-on:click.native="onConfirmClick">Save changes</core-button>

	</template>

</core-modal>

</template>

<script>

import comView from './default/View'
import $templates from './../../common/view/templates'

export default {

	props: ['data'],

    components: {
        comView
    },

	data: function() {

		return {

			is: {
				loading: false
			},

            model: {
                default: 'list'
            }

		}

	},

    created: function() {

		var context = 0

		if (this.$currentViewContext === 'collection') context = 1
		if (this.$currentViewContext === 'ratings') context = 2
		if (this.$currentViewContext === 'plays') context = 3
		if (this.$currentViewContext === 'gameplays') context = 4

		var defaultView = this.$_.find(this.$store.getters['data/views/list'], function(item) {

			return item.context === context && item.default

		})

        if(defaultView) {

            this.currentDefault = defaultView.id

        } else {

            this.currentDefault = $templates[this.$currentContextType][this.$currentViewContext].default

        }

        this.model.default = this.currentDefault

    },

	computed: {

        hasChanged: function() {

            return this.model.default !== this.currentDefault

        },
        
        context: function() {

            return this.$currentViewContext

        }

	},

	methods: {

        onConfirmClick: function() {

			this.is.loading = true

            this.$api.post('views/default', {
				context: this.context,
                view: this.model.default
			}).then(function(response) {

				this.$store.commit('session/config/set', response.config)
				this.$store.commit('data/views/set', response.views)

				if (this.$isSelf) this.$store.commit('context/config', response.config)

				this.$emit('close')

				this.$pubsub.$emit('open.modal', {
					id: 'viewsManage'
				})

			}.bind(this), function() {

				this.is.error = true
				this.is.loading = false

			}.bind(this)) 	

        },

		onClose: function() {

			this.$emit('close')

            this.$pubsub.$emit('open.modal', {
				id: 'viewsManage'
			})

		}

	}

}

</script>

<style scoped>

.text {
    padding: 20px 20px 0px 20px;
}

.is-mobile .text {
	padding: 10px 10px 0px 10px;
}

</style>